export enum BillingCycle {
  MONTHLY = 'monthly',
  ANNUAL = 'annual'
}

export interface PricingFeature {
  text: string;
  tooltip?: string;
}

export interface PricingTier {
  id: string;
  name: string;
  description: string;
  annualPrice: number;
  monthlyPrice: number;
  displayPrice: string;
  useDisplayPrice?: boolean;
  features: PricingFeature[];
  buttonText: string;
  buttonVariant: 'primary' | 'secondary';
  buttonUrl?: string;
  highlighted: boolean;
  color: string;
  level: number;
  type?: string;
}

export interface PricingData {
  tiers: PricingTier[];
}
